<template>
    <v-layout align-start>
    {{ago}}
    </v-layout align-start>

</template>

<script>
import moment from 'moment';

export default{
    components: {

    },
    props: ['createDate'],
    data () {
        return {
            ago: ''            
        }
    },
    computed: {
          
    },
    watch: {
        
    },
    created () {   
        setInterval(() => {                         
           this.ago = moment(this.createDate).fromNow();            
         }, 1000)
    },
    methods:  {
            
    },

}
</script>